/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  NativeHandoffCodeRequestRequest,
  NativeHandoffCodeResponse,
  NativeHandoffExchangeRequestRequest,
  NativeHandoffExchangeResponse,
  NativeHandoffNonceResponse,
  NativeHandoffWebCodeRequestRequest,
  NativeHandoffWebExchangeResponse
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getAuthNativeHandoffCodeCreateUrl = () => {




  return `/api/auth/native-handoff/code`
}

/**
 * Mint a single-use, ~60s, 128-bit code bound to the authenticated user and a PKCE S256 challenge. Requires a valid SuperTokens session (the Safari session cookie, or an Authorization: Bearer access token) and spends the single-use launch_nonce issued by /nonce (a handshake token from a public endpoint, not proof of a genuine app launch). The code is returned in the JSON body for the web page to hand to the native app via deep link; session tokens are never placed in a URL.
 */
export const authNativeHandoffCodeCreate = async (nativeHandoffCodeRequestRequest: NativeHandoffCodeRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<NativeHandoffCodeResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<NativeHandoffCodeResponse>(getAuthNativeHandoffCodeCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(nativeHandoffCodeRequestRequest)
  }
);}





export const getAuthNativeHandoffCodeCreateMutationKey = () => ['authNativeHandoffCodeCreate'] as const;

export const getAuthNativeHandoffCodeCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authNativeHandoffCodeCreate>>, TError,AuthNativeHandoffCodeCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof authNativeHandoffCodeCreate>>, TError,AuthNativeHandoffCodeCreateMutationVariables, TContext> => {

const mutationKey = getAuthNativeHandoffCodeCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authNativeHandoffCodeCreate>>, AuthNativeHandoffCodeCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authNativeHandoffCodeCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthNativeHandoffCodeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof authNativeHandoffCodeCreate>>>
    export type AuthNativeHandoffCodeCreateMutationBody = NativeHandoffCodeRequestRequest
    export type AuthNativeHandoffCodeCreateMutationError = void
    export type AuthNativeHandoffCodeCreateMutationVariables = {data: NativeHandoffCodeRequestRequest}

    export const useAuthNativeHandoffCodeCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authNativeHandoffCodeCreate>>, TError,AuthNativeHandoffCodeCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authNativeHandoffCodeCreate>>,
        TError,
        AuthNativeHandoffCodeCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAuthNativeHandoffCodeCreateMutationOptions(options), queryClient);
    }
    export const getAuthNativeHandoffExchangeCreateUrl = () => {




  return `/api/auth/native-handoff/exchange`
}

/**
 * Redeem a single-use handoff code with its PKCE code_verifier for a native header-mode SuperTokens session. The response carries st-access-token, st-refresh-token and front-token headers (no Set-Cookie, no tokens in the body or a URL); the body is {"status": "OK"}.
 */
export const authNativeHandoffExchangeCreate = async (nativeHandoffExchangeRequestRequest: NativeHandoffExchangeRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<NativeHandoffExchangeResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<NativeHandoffExchangeResponse>(getAuthNativeHandoffExchangeCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(nativeHandoffExchangeRequestRequest)
  }
);}





export const getAuthNativeHandoffExchangeCreateMutationKey = () => ['authNativeHandoffExchangeCreate'] as const;

export const getAuthNativeHandoffExchangeCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authNativeHandoffExchangeCreate>>, TError,AuthNativeHandoffExchangeCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof authNativeHandoffExchangeCreate>>, TError,AuthNativeHandoffExchangeCreateMutationVariables, TContext> => {

const mutationKey = getAuthNativeHandoffExchangeCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authNativeHandoffExchangeCreate>>, AuthNativeHandoffExchangeCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authNativeHandoffExchangeCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthNativeHandoffExchangeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof authNativeHandoffExchangeCreate>>>
    export type AuthNativeHandoffExchangeCreateMutationBody = NativeHandoffExchangeRequestRequest
    export type AuthNativeHandoffExchangeCreateMutationError = void
    export type AuthNativeHandoffExchangeCreateMutationVariables = {data: NativeHandoffExchangeRequestRequest}

    export const useAuthNativeHandoffExchangeCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authNativeHandoffExchangeCreate>>, TError,AuthNativeHandoffExchangeCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authNativeHandoffExchangeCreate>>,
        TError,
        AuthNativeHandoffExchangeCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAuthNativeHandoffExchangeCreateMutationOptions(options), queryClient);
    }
    export const getAuthNativeHandoffNonceCreateUrl = () => {




  return `/api/auth/native-handoff/nonce`
}

/**
 * Issue a single-use, ~10-minute launch nonce for the native app to carry into the web login. The web page returns it on the /code mint, which spends it. This endpoint is public, so the nonce is a single-use handshake token, not proof of a genuine app: the mint stays gated by the SuperTokens session, the Origin allowlist and PKCE.
 */
export const authNativeHandoffNonceCreate = async ( options?: Parameters<typeof customFetch>[1]): Promise<NativeHandoffNonceResponse> => {

  return customFetch<NativeHandoffNonceResponse>(getAuthNativeHandoffNonceCreateUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAuthNativeHandoffNonceCreateMutationKey = () => ['authNativeHandoffNonceCreate'] as const;

export const getAuthNativeHandoffNonceCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authNativeHandoffNonceCreate>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof authNativeHandoffNonceCreate>>, TError,void, TContext> => {

const mutationKey = getAuthNativeHandoffNonceCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authNativeHandoffNonceCreate>>, void> = () => {


          return  authNativeHandoffNonceCreate(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthNativeHandoffNonceCreateMutationResult = NonNullable<Awaited<ReturnType<typeof authNativeHandoffNonceCreate>>>

    export type AuthNativeHandoffNonceCreateMutationError = void


    export const useAuthNativeHandoffNonceCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authNativeHandoffNonceCreate>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authNativeHandoffNonceCreate>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAuthNativeHandoffNonceCreateMutationOptions(options), queryClient);
    }
    export const getAuthNativeHandoffWebCodeCreateUrl = () => {




  return `/api/auth/native-handoff/web-code`
}

/**
 * Mint a single-use, ~60s, 128-bit code bound to the authenticated user and a PKCE S256 challenge, for the web app to redeem at /web-exchange. Requires the native app's header-mode session as an Authorization: Bearer access token; session cookies are ignored, so a browser session cannot mint. The code is returned in the JSON body; session tokens are never placed in a URL.
 */
export const authNativeHandoffWebCodeCreate = async (nativeHandoffWebCodeRequestRequest: NativeHandoffWebCodeRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<NativeHandoffCodeResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<NativeHandoffCodeResponse>(getAuthNativeHandoffWebCodeCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(nativeHandoffWebCodeRequestRequest)
  }
);}





export const getAuthNativeHandoffWebCodeCreateMutationKey = () => ['authNativeHandoffWebCodeCreate'] as const;

export const getAuthNativeHandoffWebCodeCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authNativeHandoffWebCodeCreate>>, TError,AuthNativeHandoffWebCodeCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof authNativeHandoffWebCodeCreate>>, TError,AuthNativeHandoffWebCodeCreateMutationVariables, TContext> => {

const mutationKey = getAuthNativeHandoffWebCodeCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authNativeHandoffWebCodeCreate>>, AuthNativeHandoffWebCodeCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authNativeHandoffWebCodeCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthNativeHandoffWebCodeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof authNativeHandoffWebCodeCreate>>>
    export type AuthNativeHandoffWebCodeCreateMutationBody = NativeHandoffWebCodeRequestRequest
    export type AuthNativeHandoffWebCodeCreateMutationError = void
    export type AuthNativeHandoffWebCodeCreateMutationVariables = {data: NativeHandoffWebCodeRequestRequest}

    export const useAuthNativeHandoffWebCodeCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authNativeHandoffWebCodeCreate>>, TError,AuthNativeHandoffWebCodeCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authNativeHandoffWebCodeCreate>>,
        TError,
        AuthNativeHandoffWebCodeCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAuthNativeHandoffWebCodeCreateMutationOptions(options), queryClient);
    }
    export const getAuthNativeHandoffWebExchangeCreateUrl = () => {




  return `/api/auth/native-handoff/web-exchange`
}

/**
 * Redeem a single-use code from /web-code with its PKCE code_verifier for a new cookie-mode SuperTokens session. Only allowed web Origins may call it. The response sets the sAccessToken and sRefreshToken cookies and the front-token header (no tokens in the body or a URL); the body is {"status": "OK"}. The web session has its own refresh token, independent of the native session.
 */
export const authNativeHandoffWebExchangeCreate = async (nativeHandoffExchangeRequestRequest: NativeHandoffExchangeRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<NativeHandoffWebExchangeResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<NativeHandoffWebExchangeResponse>(getAuthNativeHandoffWebExchangeCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(nativeHandoffExchangeRequestRequest)
  }
);}





export const getAuthNativeHandoffWebExchangeCreateMutationKey = () => ['authNativeHandoffWebExchangeCreate'] as const;

export const getAuthNativeHandoffWebExchangeCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authNativeHandoffWebExchangeCreate>>, TError,AuthNativeHandoffWebExchangeCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof authNativeHandoffWebExchangeCreate>>, TError,AuthNativeHandoffWebExchangeCreateMutationVariables, TContext> => {

const mutationKey = getAuthNativeHandoffWebExchangeCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authNativeHandoffWebExchangeCreate>>, AuthNativeHandoffWebExchangeCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authNativeHandoffWebExchangeCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthNativeHandoffWebExchangeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof authNativeHandoffWebExchangeCreate>>>
    export type AuthNativeHandoffWebExchangeCreateMutationBody = NativeHandoffExchangeRequestRequest
    export type AuthNativeHandoffWebExchangeCreateMutationError = void
    export type AuthNativeHandoffWebExchangeCreateMutationVariables = {data: NativeHandoffExchangeRequestRequest}

    export const useAuthNativeHandoffWebExchangeCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authNativeHandoffWebExchangeCreate>>, TError,AuthNativeHandoffWebExchangeCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authNativeHandoffWebExchangeCreate>>,
        TError,
        AuthNativeHandoffWebExchangeCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAuthNativeHandoffWebExchangeCreateMutationOptions(options), queryClient);
    }
